<template>
   <div id="app">
      <meta name="theme-color" content="#001155" />
      <div v-if="useNavBar" class="main-wrapper flex">
        <NavSideStation v-show="isNavSideStation()" style="margin-top: 80px; padding-bottom: 80px;"/>
        <NavSideMain v-show="!isNavSideStation()" style="margin-top: 80px; padding-bottom: 80px;"/>
         <div class="site-wrapper main-wrapper js-site-wrapper">
            <NavTop />
            <div ref="page" class="page">
               <div class="container">
                  <router-view></router-view>
               </div>
            </div>
            <SwisscomFooter id="footer" />
         </div>
      </div>
      <div v-else class="main-wrapper">
         <router-view />
      </div>
   </div>
</template>

<script>
/* eslint-disable */
import NavSideMain from './components/navbar/NavSideMain/NavSideMain.vue'
import NavSideStation from './components/navbar/NavSideStation/NavSideStation.vue'
import NavTop from './components/navbar/NavTop/NavTop.vue'
import SwisscomFooter from './components/Footer/Footer.vue'

export default {
    name: 'app',
    computed: {
        useNavBar() {
            return !(this.$route.name === 'Offline' || this.$route.name === 'Login' || this.$route.name === 'SignUp' || this.$route.name === 'Confirm' || this.$route.name === 'PasswordReset')
        }
    },
    components: {
        NavSideMain,
        NavSideStation,
        NavTop,
        SwisscomFooter
    },
    watch: {
        $route() {
            this.pushOffline()
        }
    },
    methods: {
        pushOffline() {
            if (!navigator.onLine) {
                this.$router.push('/offline')
            }
        },
        isNavSideStation() {
            return this.$route.path.startsWith('/station/')
        }
    }
}
</script>

<style lang="scss">
@media only screen and (max-width: 767px) {
    #footer {
        overflow: visible;
    }
}

.page {
    .container {
        padding-top: 80px;
    }
}

#app {
    height: 100%;
}

.main-wrapper {
    height: 100%;
}

body {
    min-height: 100% !important;
    height: unset !important;
}

.iOSsmooth {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
}

@media only screen and (max-width: 480px) {
    .page {
        min-height: 100vh !important;
    }
}
</style>
